import { render, staticRenderFns } from "./ProgramWidget.vue?vue&type=template&id=972a0406&"
import script from "./ProgramWidget.vue?vue&type=script&lang=js&"
export * from "./ProgramWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports